const config = {
    REACT_APP_INSTAGRAM: window.__ENV__.REACT_APP_INSTAGRAM,
    REACT_APP_YOUTUBE: window.__ENV__.REACT_APP_YOUTUBE,
    REACT_APP_FACEBOOK: window.__ENV__.REACT_APP_FACEBOOK,
    REACT_APP_LINKEDIN: window.__ENV__.REACT_APP_LINKEDIN,
    REACT_APP_EMAIL: window.__ENV__.REACT_APP_EMAIL,
    REACT_APP_FALE_CONOSCO: window.__ENV__.REACT_APP_FALE_CONOSCO,
    REACT_APP_FALE_OUVIDORIA: window.__ENV__.REACT_APP_FALE_OUVIDORIA,
    REACT_APP_WHATSAPP: window.__ENV__.REACT_APP_WHATSAPP,
    REACT_APP_FALE_ENDERECO: window.__ENV__.REACT_APP_FALE_ENDERECO,

    REACT_APP_API_HOST: window.__ENV__.REACT_APP_API_HOST,
    REACT_APP_API_EXTERNA: window.__ENV__.REACT_APP_API_HOST,
};
export default config;
